import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IAchPayment, IAchPaymentInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class AchPaymentApiService {

  abstract getAchPayment(achPaymentId: string): Observable<IAchPayment>;

  abstract saveAchPayment(achPayment: IAchPaymentInput): Observable<any>;
}